<div class="question-container">
  <span class="question-text">{{ question }}</span>
  <label class="switch">
    <input type="checkbox" [(ngModel)]="toggleValue" (change)="onToggleChange()">
    <span class="slider round"></span>
  </label>
</div>
